<div class="header-media-type-select">
  <button
    [disabled]="form.disabled"
    [class.invalid]="!file.media_url"
    [class.active]="file.media_type === AttachmentMediaTypeEnum.Video"
    mat-raised-button
    type="button"
    (click)="selectMedia(AttachmentMediaTypeEnum.Video)">
    <mat-icon>movie</mat-icon>
  </button>
  <button
    [disabled]="form.disabled"
    [class.invalid]="!file.media_url"
    [class.active]="file.media_type === AttachmentMediaTypeEnum.Image"
    mat-raised-button
    type="button"
    (click)="selectMedia(AttachmentMediaTypeEnum.Image)">
    <mat-icon>image</mat-icon>
  </button>
  <button
    [disabled]="form.disabled"
    [class.invalid]="!file.media_url"
    [class.active]="file.media_type === AttachmentMediaTypeEnum.Document"
    mat-raised-button
    type="button"
    (click)="selectMedia(AttachmentMediaTypeEnum.Document)">
    <mat-icon>attach_file</mat-icon>
  </button>
</div>
<input #fileInput (change)="uploadMedia($event)" [accept]="supportedMediaTypes" hidden type="file" />

<mat-checkbox class="static-header-option" [formControl]="$any(form.controls.static)">
  <span translate="parameters/whatsapp-templates/content/header/static-header"></span>
</mat-checkbox>
